import { type EntitiesBets } from '../../../states/entities/bets';
import { type BetState } from '../../../states/entities/bets';
import { type BetId } from '../../../states/entities/bets';
import { type StateType } from '../../../states/index';
import { type BetType, type BetTemplate } from '../../../types/bet';
import { type Selector } from '../../../types/selectors';
import { getBetIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesBets: Selector<EntitiesBets> = (state: StateType) =>
  selectEntitiesState(state).bets ?? emptyObject;

//#region state.entities.bets
export type EntitiesBetsSelectorProps = {
  betId?: BetId;
};

export const selectEntitiesBetsEntity: Selector<BetState | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => {
  const betId = getBetIdFromProps(state, props);

  if (betId) {
    return selectEntitiesBets(state)[betId];
  }
};
//#endregion

//#region state.entities.bets[betId]
export const selectEntitiesBetsEntityBetId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betId;

export const selectEntitiesBetsEntityAvailable: Selector<boolean> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.available ?? false;

export const selectEntitiesBetsEntityBetGroup: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betGroup;

export const selectEntitiesBetsEntityTemplate: Selector<BetTemplate | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.template;

export const selectEntitiesBetsEntityBetTypeIsLive: Selector<boolean> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betTypeIsLive ?? false;

export const selectEntitiesBetsEntityBetTypeName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betTypeName;

export const selectEntitiesBetsEntityBetTypeHelp: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betTypeHelp;

export const selectEntitiesBetsEntityBetTypeCategory: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betTypeCategory;

export const selectEntitiesBetsEntityBetTypeCategoryId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betTypeCategoryId;

export const selectEntitiesBetsEntityBetTitle: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betTitle;

export const selectEntitiesBetsEntityBetType: Selector<BetType | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betType;

export const selectEntitiesBetsEntityBetTypeId: Selector<BetType | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.betTypeId;

export const selectEntitiesBetsEntityOutcomes: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.outcomes;

export const selectEntitiesBetsEntitySpecialBetValue: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.specialBetValue;

export const selectEntitiesBetsEntityIsAlternativeMainBet: Selector<boolean> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.isAlternativeMainBet ?? false;

export const selectEntitiesBetsEntityMarketId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.marketId;

export const selectEntitiesBetsEntityHelperText: Selector<string | undefined | null> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.helperText;

export const selectEntitiesBetsEntityPreviousOdd: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.previousOdd;

export const selectEntitiesBetsEntityNoCombo: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.noCombo;

export const selectEntitiesBetsEntityIsHighlighted: Selector<boolean | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.isHighlighted ?? false;

export const selectEntitiesBetsEntityCurrentTotal: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.currentTotal;

export const selectEntitiesBetsEntityMarketTotal: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesBetsSelectorProps = {},
) => selectEntitiesBetsEntity(state, props)?.marketTotal;
//#endregion
